import React from 'react';

/**
 * Props for the LoadingSpinner component
 */
interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * A loading spinner component using Bootstrap's spinner
 * Follows Bootstrap best practices and supports dark mode
 */
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'md', className = '' }) => {
  // Map size prop to Bootstrap size classes
  // Bootstrap only has spinner-border-sm, regular size has no suffix
  const sizeClass = size === 'sm' ? 'spinner-border-sm' : '';
  
  // Adjust the container size and padding based on spinner size
  const containerClass = size === 'lg' ? 'py-4' : size === 'md' ? 'py-3' : 'py-2';
  
  // Use Bootstrap's sizing utilities for large spinners
  const spinnerClass = `spinner-border ${sizeClass} ${size === 'lg' ? 'spinner-border-lg' : ''} text-primary`;
  
  return (
    <div className={`d-flex justify-content-center align-items-center ${containerClass} ${className}`}>
      <div 
        className={spinnerClass}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default LoadingSpinner; 